import { SignIn } from "@clerk/clerk-react";
import Logo from "../../components/Logo";

export default function Login() {
  return (
    <div className="min-h-screen bg-mist flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <Logo size={44} className="mb-3" />
          <p className="text-muted text-sm">
            Create a week of posts in minutes.
          </p>
        </div>

        <SignIn
          routing="hash"
          signUpUrl="/login#/sign-up"
          appearance={{
            elements: {
              card: "card shadow-none border border-gray-200",
              headerTitle: "text-xl font-semibold text-ink",
              headerSubtitle: "text-sm text-muted",
              formButtonPrimary: "btn-primary w-full py-2.5 text-sm",
              footerActionLink:
                "text-brand-600 hover:text-brand-700 font-medium",
              socialButtonsBlockButton:
                "flex items-center justify-center gap-3 w-full px-4 py-2.5 border border-gray-300 rounded-lg bg-white text-sm font-medium text-slate hover:bg-gray-50 transition-colors",
            },
          }}
        />

        <p className="text-center text-xs text-faint mt-6">
          Free plan: 5 posts/month. No credit card required.
        </p>
      </div>
    </div>
  );
}
